export default "__VITE_ASSET__CBzklFZX__"